import { get } from 'lodash';
import moment from 'moment';
import { schema } from 'normalizr';

import { PayloadApiRequest } from '@lib/actions/sagaApi';
import createResource from '@lib/resources/createResource';
import { Activity } from '@lib/resources/types';

import activityContextsResource from './activityContextsResource';
import facilitiesResource from './facilitiesResource';
import patientsResource from './patientsResource';
import providersResource from './providersResource';
import usersResource from './usersResource';

export const HOURS_OLD_ACTIVITY = 36;

const idAttribute = (value: any) =>
  value._id ||
  // NOTE: There might be 2 different activities with the same `activityContext._id`,
  // so we use the namespace prefix in order to have a unique ID
  `${value.namespace}:${get(value.activityContext, '_id')}:${value.timestamp}`;

const activitiesResource = createResource<Activity>({
  idAttribute,
  key: 'activities',
  url: '/activities',
  fetchPageUrl: '/activities',
  createFetchPageSchema: (s) => new schema.Array(s),
  createFetchListSchema: (s) => new schema.Array(s),
  lookups: {
    facility: facilitiesResource,
    patient: patientsResource,
    provider: providersResource,
    activityContext: activityContextsResource,
    user: usersResource,
  },
  processStrategy: (data) => ({
    ...data,
    id: idAttribute(data),
    $isRecent: moment().diff(moment(data.timestamp), 'hours') <= HOURS_OLD_ACTIVITY,
  }),
});

const customActions = {
  takeActivity: (activity: Activity, payload?: PayloadApiRequest<Activity>) =>
    activitiesResource.request({
      url: `${activitiesResource.url}/${activity.timestamp}`,
      method: 'put',
      data: { actionTaken: true },
      ...payload,
      meta: {
        schema: activitiesResource.schema,
        ...get(payload, 'meta'),
      },
    }),
};

export default {
  ...activitiesResource,
  ...customActions,
};
